module.exports = __webpack_public_path__ + "img/green-eye-icon.f9914200.svg";